import React from "react";
import { ReactComponent as Icon } from "../../../../../assets/icons/conseilsPros/rapportsColorsCTA.svg";

function RapportsColorsCTA({ height = "100px", className, onClick }) {
  return <Icon height={height} width={height} className={className} onClick={onClick} />;
}

export default RapportsColorsCTA;
